import React, { ChangeEvent, useCallback, useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import { useHistory, useLocation } from 'react-router-dom';

import api from '../../services/api';

import { useToast } from '../../hooks/toast';

import Button from '../../components/Button';

import { Content, UploadNewsInput } from './styles';
import StandardContainer from '../../components/StandardContainer';
import Header from '../../components/Header';

interface LocationState {
  id: string;
};

const NewsUpload = () => {
  const { addToast } = useToast();
  const history = useHistory();

  const { state } = useLocation<LocationState>();

  const [file, setFile] = useState<File>();
  const [loading, setLoading] = useState(false);

  const handleImageChange = useCallback(
    (e: ChangeEvent<HTMLInputElement>) => {
      if (e.target.files) {
        setFile(e.target.files[0]);
      }
    },
    [setFile],
  );

  const handleUploadImage = useCallback(async () => {
    setLoading(true);
    try {
      if (file) {
        const data = new FormData();
        data.append('image', file);

        await api.patch(`/news/${state.id}/image`, data);
        history.push('/news');

        addToast({
          type: 'success',
          title: 'Imagem da notícia atualizada!',
        });
      }
    } catch (err) {
      addToast({
        type: 'error',
        title: 'Erro ao atualizar imagem!',
        description: 'Tente novamente mais tarde :)',
      });
    }

    setLoading(false);
  }, [addToast, file, history, state.id]);

  return (
    <StandardContainer>
      <Header />
      <Content>
        <h1>Adicionar imagem da notícia</h1>

        <UploadNewsInput>
          <input disabled value={file?.name} />
          <label htmlFor="uploadNews">
            <FiUpload />
            <input type="file" id="uploadNews" onChange={handleImageChange} />
          </label>
        </UploadNewsInput>
        <Button onClick={handleUploadImage} loading={loading}>Salvar</Button>
      </Content>
    </StandardContainer>
  )
}

export default NewsUpload;
